module.exports = __webpack_public_path__ + "static/media/Header.aaa43132.png";